import { forwardRef, type LabelHTMLAttributes, type ReactElement } from 'react'
import { cn } from '@/lib/utils'

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref): ReactElement => (
    <label
      ref={ref}
      className={cn(
        'text-xs font-medium uppercase tracking-wider text-muted-foreground',
        className,
      )}
      {...props}
    />
  ),
)
Label.displayName = 'Label'
